export default __webpack_public_path__ + "static/media/greenland.38cbb86b.png";